import React, {Component} from 'react'
import {createNewBox} from "../../../services/api/apiNextBox"
import getHistory from "../../../getHistory"


class CreateNewBox extends Component {
    state = {
        loading: false,
    }

    _handleClick = e => {
        e.preventDefault()

        return this._createNewBox()
    }

    _createNewBox = async () => {
        if (this.state.loading) return true

        this.setState({
            loading: true
        })

        try {
            const {success, data, message} = await createNewBox()

            if (!success) {
                throw new Error(message)
            }

            const {_id} = data
            const history = getHistory()
            history.push(`/next-boxes/${_id}`)
        } catch (e) {
            this.setState({loading: false}, () => {
                window.alert('Lỗi: ' + e.message)
            })
        }

    }

    render() {
        const {loading} = this.state

        return (
            <div className="CreateNewBox">
                <button disabled={loading} onClick={this._handleClick} className="btn btn-primary">
                    Tạo thùng mới
                </button>
            </div>
        )
    }
}

export default CreateNewBox
